import { TmdxAvatar } from '@ds';
import { formatSuggestionDate } from '@lp/features/MultiSuggest/utils';
import { MultiSuggestEmployeeRoleList } from '@lp/features/MultiSuggest';
import { useMultiSuggestionItemQuery } from '@/queries/multi-suggest';

type RequestDetailsProps = {
  taskId: string;
};

export const RequestDetails = ({ taskId }: RequestDetailsProps) => {
  const { data } = useMultiSuggestionItemQuery(taskId);

  if (!data) return null;

  return (
    <div className="flex flex-col gap-3 p-2">
      <span className="text-m-cps text-base-20 uppercase">Request details</span>
      <div className="flex gap-2 items-center">
        <span className="text-l-r text-base-5">Initiated by</span>
        <div className="flex gap-2 items-center">
          <TmdxAvatar radius="sm" size="sm" name={data.user.fullName} src={data.user.photo} />
          <div className="flex gap-1 items-center">
            <span className="text-m-r text-base-10">{data.user.fullName}</span>
            <MultiSuggestEmployeeRoleList roles={data.user.roles} />
          </div>
        </div>
      </div>
      <div className="flex gap-2 items-center">
        <span className="text-l-r text-base-5">Initiated date</span>
        <span className="text-m-r text-base-10">{formatSuggestionDate(data.initiatedDate)}</span>
      </div>
      <div className="flex gap-2 items-center">
        <span className="text-l-r text-base-5">Suggested date</span>
        <span className="text-m-r text-base-10">{formatSuggestionDate(data.suggestedDate)}</span>
      </div>
    </div>
  );
};
